module.exports = __webpack_public_path__ + "static/media/01B.2ea96715.png";